import React from 'react'
import { TableCell } from '@mui/material';

import * as S from './styles';
import { SearchGridRequoteTraceabilityResponse } from '@/main/models/response';

interface IRowDataRequoteTraceabilityProps {
  itemRow: SearchGridRequoteTraceabilityResponse;
}

function RowDataRequoteTraceability({
  itemRow,
}: IRowDataRequoteTraceabilityProps) {

  return (
    <S.Container $isSizeLong $notClickable>
      <TableCell><S.CustomColumn title={itemRow.insurer}>{itemRow.insurer}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={itemRow.actionFormatted}>{itemRow.actionFormatted}</S.CustomColumn></TableCell>
      <TableCell><S.CenterColumn title={String(itemRow.originalQuoteNr)}>{itemRow.originalQuoteNr}</S.CenterColumn></TableCell>
      <TableCell><S.CustomColumn title={itemRow.userName}>{itemRow.userName}</S.CustomColumn></TableCell>
      <TableCell><S.CenterColumn title={String(itemRow.quoteNr)}>{itemRow.quoteNr}</S.CenterColumn></TableCell>
      <TableCell><S.CustomColumn title={itemRow.quoteStatusFormatted}>{itemRow.quoteStatusFormatted}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={itemRow.quotePartStatusFormatted}>{itemRow.quotePartStatusFormatted}</S.CustomColumn></TableCell>
      <TableCell><S.CenterColumn title={String(itemRow.requotes)}>{itemRow.requotes}</S.CenterColumn></TableCell>
      <TableCell><S.CustomColumn title={String(itemRow.quoteDateFormat)}>{itemRow.quoteDateFormat}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={itemRow.claimNr}>{itemRow.claimNr}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={itemRow.policyNr}>{itemRow.policyNr}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={itemRow.partName}>{itemRow.partName}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={itemRow.bodyshopRfc}>{itemRow.bodyshopRfc}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={itemRow.bodyshopName}>{itemRow.bodyshopName}</S.CustomColumn></TableCell>
    </S.Container>
  );
}

export default RowDataRequoteTraceability